import { ThemeOptions } from '@mui/material';

import * as MuiAccordionConfig from './MuiAccordion';
import * as MuiCardConfig from './MuiCard';
import * as MuiPaperConfig from './MuiPaper';

export type {} from './MuiAccordion';
export type {} from './MuiCard';
export type {} from './MuiPaper';

export const surfaces: ThemeOptions['components'] = {
  ...MuiAccordionConfig,
  ...MuiCardConfig,
  ...MuiPaperConfig
};
